export const DEFAULT_BOOKING = 'Z53DVDE';
export const CANCELLED_BOOKING = 'Z53DVDE-CANCELED';
export const STARTED_BOOKING = 'Z53DVDE-STARTED';
export const WAITLIST_BOOKING = 'Z53DVDE-WAITLIST';
export const BOOKING_WITH_NOTE = 'Z53DVDE-BOOKING_WITH_NOTE';
export const CANCELED_WAITLIST_BOOKING = 'Z53DVDE-CANCELED_WAITLIST';
export const CONFIRMED_BOOKING = 'Z53DVDE-CONFIRMED';
export const NO_FEE_BOOKING = 'Z53DVDE-NO-FEE';
export const PER_RESERVATION_FEE_BOOKING = 'Z53DVDE-PER-RES-FEE';
export const BOOKING_WITH_EMPTY_EMAIL = 'Z53DVDE-EMPTY-EMAIL';
export const BOOKING_WITH_INVALID_EMAIL = 'Z53DVDE-INVALID-EMAIL';
export const BOOKING_WITH_RES_DETAILS = 'Z53DVDE-RES-DETAILS';
export const NO_CHECKLESS_PAYMENTS_BOOKING = 'Z53DVDE-NO-CHECKLESS-PAYMENTS';
export const USHG_BOOKING = 'Z53DVDE-USHG';
export const CANCELED_USHG_BOOKING = 'Z53DVDE-CANCELED-USHG';
export const UNENROLLED_BOOKING = 'Z53DVDE-UNENROLLED';
export const INTEGRATION_TEST_BOOKING = 'Z53DVDE-BOOKING-WITH-FEE';
export const INTEGRATION_TEST_CANCELLED_BOOKING =
  'Z53DVDE-CANCELED-BOOKING-WITH-FEE';
export const SPECIAL_REQUEST_STEP_1 = 'RM6617-NEW-SPECIAL-REQUEST-STEP-1';
export const SPECIAL_REQUEST_STEP_2 = 'RM6617-NEW-SPECIAL-REQUEST-STEP-2';
export const UNENROLLMENT_INITIAL_DATA = 'RM6269-UNENROLLMENT-STEP1';
export const UNENROLLMENT_FINAL_DATA = 'RM6269-UNENROLLMENT-STEP2';
export const UNENROLLMENT_CUSTOM_GRATUITY_INITIAL_DATA =
  'RM6272-UNENROLLMENT-STEP1';
export const UNENROLLMENT_CUSTOM_GRATUITY_FINAL_DATA =
  'RM6272-UNENROLLMENT-STEP2';
export const UNENROLLMENT_UPDATE_GRATUITY_INITIAL_DATA =
  'RM6274-UNENROLLMENT-STEP1';
export const UNENROLLMENT_UPDATE_GRATUITY_FINAL_DATA =
  'RM6274-UNENROLLMENT-STEP2';
export const REDIRECT_TO_LIVE_CHECK = 'REDIRECT_TO_LIVE_CHECK';
export const WAITLIST_BOOKING_READY = 'WAITLIST_BOOKING_READY';
export const WAITLIST_WAITTIME_OVER = 'WAITLIST_WAITTIME_OVER';
export const COMPLEX_SPECIAL_OCCASIONS = 'COMPLEX_SPECIAL_OCCASIONS';
export const GUEST_BOOKING = 'GUEST_BOOKING';
export const GUEST_NOT_ATTENDING = 'GUEST_NOT_ATTENDING';
export const GUEST_CHECK_SPLITTING_NOT_ENABLED =
  'GUEST_CHECK_SPLITTING_NOT_ENABLED';
export const GUEST_LIST_FULL_BOOKING = 'GUEST_LIST_FULL_BOOKING';
export const WAITLIST_GUEST_LIST_FULL = 'WAITLIST_GUEST_LIST_FULL';
export const LEAD_BOOKING_ENROLLED = 'LEAD_BOOKING_ENROLLED';
export const GUEST_LIST_MORE_GUESTS = 'GUEST_LIST_MORE_GUESTS';
export const GUEST_LIST_WITH_LEAD = 'GUEST_LIST_WITH_LEAD';
export const GUEST_LIST_SOME_SPLITTING = 'GUEST_LIST_SOME_SPLITTING';
export const GUEST_BOOKING_WITH_SPLIT = 'GUEST_BOOKING_WITH_SPLIT';
export const BOOKING_WITH_JOIN = 'BOOKING_WITH_JOIN';
export const BOOKING_FULL_WITH_JOIN = 'BOOKING_FULL_WITH_JOIN';
